import { call, put, takeEvery, takeLeading } from 'typed-redux-saga'
import { errorHandler, loadersSlice, notifyMessageCreator } from 'Modules'
import { AnswerNS, answersApi, answerSlice, attemptSlice } from 'Pages/survey'

function* createOne(action: AnswerNS.CreateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { attempt_id, question_id, data, callback } = action.payload
		const res = yield* call(answersApi.createOne, attempt_id, question_id, data)
		callback?.(res.id)
		yield* put(attemptSlice.actions.getOne({ id: attempt_id }))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		const { errorCallback } = action.payload
		const errors = error?.data?.errors
		const isFileError = errors.some((o) => Object.keys(o)?.[0]?.includes('attachment'))
		if (isFileError) {
			errorCallback?.(Object.keys(errors?.[0] ?? {}).map((key) => errors[0][key]))
		} else {
			yield* call(errorHandler, error)
		}
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* updateOne(action: AnswerNS.UpdateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { answer_id, data, callback } = action.payload
		const res = yield* call(answersApi.updateOne, answer_id, data)
		callback?.()
		yield* put(attemptSlice.actions.getOne({ id: res.attempt_id }))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		const { errorCallback } = action.payload
		const errors = error?.data?.errors
		const isFileError = errors.some((o) => Object.keys(o)?.[0]?.includes('attachment'))
		if (isFileError) {
			errorCallback?.(Object.keys(errors?.[0] ?? {}).map((key) => errors[0][key]))
		} else {
			yield* call(errorHandler, error)
		}
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* deleteOne(action: AnswerNS.DeleteOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { callback, id } = action.payload
		yield* call(answersApi.deleteOne, id)
		yield* call(notifyMessageCreator, 'common.option_delete.success')
		callback?.()
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export const answerSaga = function* saga() {
	yield* takeEvery(answerSlice.actions.createOne.type, createOne)
	yield* takeLeading(answerSlice.actions.updateOne.type, updateOne)
	yield* takeEvery(answerSlice.actions.deleteOne.type, deleteOne)
}
